export enum Page {
  consent = 'consent',
  signup = 'signup',
  resetPassword = 'reset',

  /**
   * SIGNUP
   */

  oura = 'oura',
  plans = 'plans',
  code = 'secret',
  credentials = 'credentials',
  goal = 'goal',
  measuringDevice = 'measuring-device',
  coveredByInsurance = 'covered-by-insurance',
  chooseProvider = 'choose-provider',
  providerInfo = 'provider-info',
  clarifyProvider = 'clarify-provider',
  address = 'address',
  payment = 'payment',
  orderSummary = 'order-summary',
  login = 'login',

  /**
   * QUIZ
   */
  // === SECTION 1
  fertilityGoal = 'fertility-goal',
  privacy = 'privacy',
  name = 'name',
  usps = 'usps',
  birthday = 'birthday',

  // === SECTION 2
  // ====== prevent
  fertilityGoalInfo = 'fertility-goal-info',

  birthControlMethod = 'birth-control-method',

  birthControlMethodInfo = 'birth-control-method-info',
  sideEffects = 'side-effects',
  sideEffectsInfo = 'side-effects-info',
  // ====== plan
  plannedPregnancyTiming = 'planned-pregnancy',

  // sex questions - start
  learnAboutSex = 'learn-about-sex',
  menstrualCycleInfo = 'menstrual-cycle-info',
  sexDriveInfo = 'sex-drive-info',
  testimonialInfo = 'testimonial-info',
  bestTimeInCycle = 'best-time-in-cycle',
  knowingYourSexDrive = 'knowing-your-sex-drive',
  sexFrequency = 'sex-frequency',
  knowPregnantDays = 'know-pregnant-days',
  // sex questions - end

  // === SECTION 3
  hormonalBirthControlUsage = 'hormonal-birth-control-usage',

  // These two pages look the same, but their output is different, therefore it is better to keep them separate
  hormonalBirthControlHowLongPlan = 'hormonal-birth-control-how-long-plan',
  hormonalBirthControlHowLongPrevent = 'hormonal-birth-control-how-long-prevent',
  // =============================================================

  plannedPregnancyInfo = 'planned-pregnancy-info',
  cycleLength = 'cycle-length',
  periodRegularity = 'period-regularity',
  periodRegularityInfo = 'period-regularity-info',
  cycleStartDate = 'cycle-start-date',

  // These two pages look the same, but their output is different, therefore it is better to keep them separate
  medicalConditionsPlan = 'medical-conditions-plan',
  medicalConditionsPrevent = 'medical-conditions-prevent',
  // =============================================================

  medicalConditionsInfo = 'medical-conditions-info',
  periodTrackerComparison = 'period-tracker-comparison',
  periodTrackerUsage = 'period-tracker-usage',
  whichPeriodTracker = 'which-period-tracker',
  doctorInvolvement = 'doctor-involvement',
  partnerInvolvement = 'partner-involvement',
  partnerInvolvementInfo = 'partner-involvement-info',
  followPregnancyInfo = 'follow-pregnancy-info',

  // === SECTION 4
  emotionalChanges = 'emotional-changes',
  cycleChanges = 'cycle-changes',
  // ====== sub cycle changes
  cycleChangesEmotions = 'emotions',
  cycleChangesBleeding = 'bleeding',
  cycleChangesSkin = 'skin',
  cycleChangesSexAndLibido = 'sex-and-libido',
  cycleChangesCervicalMucus = 'cervical-mucus',
  cycleChangesPain = 'pain',
  // =======================
  trackingInfo = 'tracking-info',

  // === SECTION 5
  naturalMethod = 'natural-method',
  yourMeasuringDevice = 'your-measuring-device',
  whichWearable = 'which-wearable',
  eligibleAppleWatch = 'eligible-apple-watch',
  purchaseNewWatch = 'purchase-new-watch',
  equallyEffectiveInfo = 'equally-effective-info',
  nightSleep = 'night-sleep',
  troubleGettingBackToSleep = 'trouble-getting-back-to-sleep',
  sleepWearable = 'sleep-wearable',
  wearYourWatchToBed = 'wear-your-device-to-bed',
  sleepConsistency = 'sleep-consistency',
  spendingDaysInfo = 'spending-days-info',
  feelingStressed = 'feeling-stressed',
  healthGoals = 'health-goals',
  biggestStressor = 'biggest-stressor',
  favoriteWayToUnwind = 'favorite-way-to-unwind',
  deviceTrait = 'device-trait',
  fitResult = 'fit-result',
  deviceResult = 'device-result',
  resultOverview = 'result-overview',

  // ab-312 - QUIZ CHAPTERS
  introChapter = 'intro-chapter',
  goalChapter = 'goal-chapter',
  cycleChapter = 'cycle-chapter',
  changesChapter = 'changes-chapter',
  routineChapter = 'routine-chapter',
  // === Redirects
  /**
   * We'd like to be able to navigate back to the quiz from the flow, without
   * having to depend on quizService. This page is a solution to that that
   * defers the decision of what the last page is to the can.activate.quiz guard.
   */
  lastQuizPage = 'last-quiz-page',

  // test 343 - CYCLE PHASE
  periodLength = 'period-length',
  avgCycleLength = 'avg-cycle-length',
  cyclePhaseInfo = 'cycle-phase-info',
  tailoredInsights = 'tailored-insights',

  // test 351 - Needs intro
  needsIntro = 'needs-intro',
  yourBody = 'your-body',
  understandingCycle = 'understanding-cycle',
  switchToNc = 'switch-to-nc',
  hesitations = 'hesitations',
  ncInfo = 'nc-info',
  statementResearch = 'statement-research',
  researchInfo = 'research-info',

  // test 358
  newsletter = 'newsletter',

  // test 371
  whatToTrack = 'what-to-track',
  wearYourWatchToSleep = 'wear-your-watch-to-sleep',
  sleepAndLifestyle = 'sleep-and-lifestyle',
  dailyRoutine = 'daily-routine',
  wakeUpTime = 'wake-up-time',
  snooze = 'snooze',

  // test 367
  typicalUse = 'typical-use',
}

export enum ParentPage {
  quiz = 'onboarding',
  clearblue = 'clearblue',
}

export enum ActivatePage {
  credentials = 'credentials',
  orderSummary = 'order-summary',
}

export enum ManageAccountPage {
  account = 'account',
  billing = 'billing',
  plans = 'plans',
  settings = 'settings',
  profile = 'profile',
  address = 'address',
  payment = 'payment',
  orderSummary = 'order-summary',
}

export enum ClearbluePage {
  code = 'code',
  success = 'success',
  failure = 'failure',
  offer = 'offer',
}

export type AnyPage = Page | ManageAccountPage | ClearbluePage | ParentPage | ActivatePage
